module.exports = __webpack_public_path__ + "static/img/background.6a647d77.svg";